<template>
  <div class="container">
    <el-row type="flex" justify="center">
      <el-col :xs="22" :sm="22" :md="23" :lg="18" :xl="16" class="center">
        <el-row type="flex" class="row-bg" justify="center">
          <el-col :span="9" style="margin-top:0px">
            <div style="text-align:center;height:300px;width:100%;display: flex;align-items: center;justify-content: center;">
              <img :src="imgUrl" style="width: 80%; height: 122%; object-fit: contain; object-position: center;">
            </div>
          </el-col>
          <el-col :span="9" style="border-left:1px solid lightgray;padding-top:20px">
            <h2 style="text-align:center;color:#09273e;">登录管理系统</h2>
            <el-form :model="loginForm" status-icon :rules="rules" ref="loginForm" label-width="50px" class="demo-ruleForm" @submit.native.prevent>
              <el-form-item prop="name">
                <el-input type="text" placeholder="用户名" @keyup.enter.native="submitForm('loginForm')" v-model="loginForm.name" auto-complete="off"
                  oninput="this.value=this.value.replace(/[, ]/g,'')">
                </el-input>
              </el-form-item>
              <el-form-item prop="pass">
                <el-input type="password" placeholder="密码" @keyup.enter.native="submitForm('loginForm')" v-model="loginForm.pass" auto-complete="off"
                  oninput="this.value=this.value.replace(/[, ]/g,'')">
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="submitForm('loginForm')" style="width:100%;">确定</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { login } from 'api/login';
import { mapActions } from 'vuex';
import { SET_ACC_INFO } from '../../../store/mutation-type';
import { setCookie, delCookie } from '@/assets/common/common';
import crypto from '@/assets/common/cryptoJ';

export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        callback('请输入用户名');
      } else {
        if (this.loginForm.name !== '') {
        }
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback('请输入密码');
      } else {
        if (this.loginForm.pass !== '') {
        }
        callback();
      }
    };
    return {
      loginForm: {
        name: '',
        pass: '',
        check: '',
      },
      rules: {
        name: [
          { validator: validateName, trigger: 'blur' },
        ],
        pass: [
          { validator: validatePass, trigger: 'blur' },
        ],
      },
      checked: false,
      imgUrl: '',
      // imgUrl: require('@/assets/images/lkd.png'),
      // imgUrl: require('@/assets/images/yunpeng.png'),
      // imgUrl: require('@/assets/images/lc.jpg')
      // imgUrl: require('@/assets/images/标志+中英文上下.jpg'),
    };
  },
  beforeRouteEnter(to, from, next) {
    sessionStorage.clear();
    const baseRightUrl = window.location.href;
    const rightData = baseRightUrl.split('/');
    next((vm) => {
      switch (rightData[3]) {
        case 'SMP':
        case 'SCM':
          // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/icon.png'
          vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/icon.png';
          // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/icon.png'
          // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/yunpeng/icon.png'
          // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/icon.png'
          break;

        case '#':
          // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/mjd/icon.png'
          vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/lkd/icon.png';
          // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/mjd/icon.png'
          // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/yunpeng/icon.png'
          // vm.imgUrl = 'https://service.linkda.com.cn/file/tcpics/yunpeng/icon.png'
          break;

        default:
          vm.imgUrl = `https://service.linkda.com.cn/file/tcpics/${rightData[3]}/icon.png`;
          // vm.imgUrl = 'https://service1.mckintey.top/file/tcpics/'+ rightData[3]+ '/icon.png'
          break;
      }
      // vm.getddvoidLogin()
    });
  },
  methods: {
    ...mapActions([SET_ACC_INFO]),
    forget() {
      this.$router.push({ name: 'forget' });
    },
    submitForm(formName) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              const pro_passWord = crypto.encrypt(this.loginForm.pass, 'zAr6egnLKD9S4T2k');
              const data = {
                ACCOUNT: this.loginForm.name,
                PASSWORD: pro_passWord,
              };
              const rememberStatus = this.checked;
              const userInfo = `${data.ACCOUNT}&${data.PASSWORD}`;
              login(data).then((result) => {
                if (result[0].IS_ORG_PWD === 1) {
                  sessionStorage.setItem('userId', result[0].USER_ID);
                  sessionStorage.setItem('session', result[0].SESSION);
                  this.$router.push({ name: 'loginEditPass' });
                  document.body.style.cursor = 'default';
                } else {
                  const accountInfo = {
                    name: result[0].NAME,
                    userId: result[0].USER_ID,
                    userName: this.loginForm.name,
                  };
                  this[SET_ACC_INFO]({ ...accountInfo });
                  // 勾选记住密码，保存到Cookie中
                  if (rememberStatus) {
                    setCookie('userInfo', userInfo, 1440 * 3);
                    document.body.style.cursor = 'default';
                  } else {
                    delCookie('userInfo');
                    document.body.style.cursor = 'default';
                  }
                  this.$message.show({ text: '登录成功', type: 'success' });
                  sessionStorage.setItem('tcId', result[0].COMPANY_ID);
                  sessionStorage.setItem('name', result[0].NAME);
                  sessionStorage.setItem('userId', result[0].USER_ID);
                  sessionStorage.setItem('session', result[0].SESSION);
                  sessionStorage.setItem('company', result[0].COMPANY_NAME);
                  sessionStorage.setItem('isChange', result[0].BE_TW);
                  sessionStorage.setItem('BE_PRICE', result[0].BE_PRICE);
                  sessionStorage.setItem('catalogNum', result[0].CATALOG_LEVEL_NUM);
                  sessionStorage.setItem('asyncRouterMap', JSON.stringify(result[0].MENUS));
                  sessionStorage.setItem('IS_USING_WAREHOUSE', result[0].IS_USING_WAREHOUSE);
                  sessionStorage.setItem('PRICE_MODE', result[0].PRICE_MODE);
                  sessionStorage.setItem('WAREHOUSE_MODE', result[0].WAREHOUSE_MODE);
                  sessionStorage.setItem('XF_FLAG', result[0].XF_FLAG);
                  sessionStorage.setItem('IS_USE_KG', result[0].IS_USE_KG);
                  sessionStorage.setItem('accountCloseList', JSON.stringify(result[0].accountCloseList));
                  sessionStorage.setItem('登录系统', 'SCM');
                  sessionStorage.setItem('箱规是否能够使用小数点', result[0].IS_SUPPORT_DECIMAL_POINT);
                  sessionStorage.setItem('是否使用自有分类', result[0].STOCK_DEFAULT_CATALOG); // 0自有分类 1 默认分类

                  this.$router.push({ name: 'welcome' });
                  document.body.style.cursor = 'default';
                }
              }).catch((error) => {
                this.$message.show({ text: error, type: 'error' });
                document.body.style.cursor = 'default';
              });
            } else {
              document.body.style.cursor = 'default';
            }
          });
        } finally {}
      }
    },
    rememberPassword() {
    },
  },
};
</script>
<style scoped>
.container {
  position: absolute;
  width: 100%;
  height: 100%;
  /* background: url('../../assets/images/background1.jpg') no-repeat; */
  background: url("../../assets/images/backnologo.jpg") no-repeat;
  /* background: url('../../assets/images/lcback.png') no-repeat; */
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
  z-index: 10;
}

.center {
  margin-top: 10%;
  padding-top: 50px;
  padding-bottom: 50px;
  background: url("../../assets/images/center.png") no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  -webkit-background-size: 100% 100%;
}

.el-form {
  margin-right: 50px;
  margin-top: 30px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  min-height: 36px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/login.vue